<script setup lang="ts">
defineProps<{
  discountPercentage: number;
}>();
</script>

<template>
  <span
    class="absolute -right-1 -top-2 z-10 flex aspect-square rotate-6 items-center justify-center rounded-full bg-yellow p-1 text-xs font-bold shadow"
  >
    {{ discountPercentage }}%
  </span>
</template>
